import UiPageListSearch from "./UiPageListSearch";
import UiPageListSearch_DynamicSearchItem from "./UiPageListSearch_DynamicSearchItem";
import { EnumUiDynamicSearchItemType } from "./EnumUiDynamicSearchItemType";
import { EnumCompare } from "./EnumCompare";

/**
 * 
 * @description 自动生成的代码,请勿修改
 */
export default class DtoPageListSearchServerLog extends UiPageListSearch {
    constructor() {
        //无参构造函数
        super()
    }

    [proName: string]: any;
    /**
     * 站点Id
     */
    SiteId?: string;
    /**
     * 日期
     */
    Path?: string;
}

/**
 * -表单校验
 */
export const DtoPageListSearchServerLogRules = {
}

/**
 * -动态搜索配置项
 */
export const DtoPageListSearchServerLogDynamicSearchItems: UiPageListSearch_DynamicSearchItem[]  = [
  {
    Prop: "DynamicSearch_Message",
    Label: "消息",
    Type: EnumUiDynamicSearchItemType.InputText,
    Compares: [
      EnumCompare.Equal,
      EnumCompare.NoEqual,
      EnumCompare.Contain,
      EnumCompare.NoContain,
    ]
  },
  {
    Prop: "DynamicSearch_RequestId",
    Label: "请求Id",
    Type: EnumUiDynamicSearchItemType.InputText,
    Compares: [
      EnumCompare.Equal,
      EnumCompare.NoEqual,
      EnumCompare.Contain,
      EnumCompare.NoContain,
    ]
  },
  {
    Prop: "DynamicSearch_Method",
    Label: "请求方式",
    Type: EnumUiDynamicSearchItemType.Customize,
    Compares: [
      EnumCompare.Equal,
      EnumCompare.NoEqual,
    ]
  },
  {
    Prop: "DynamicSearch_ElapsedMilliseconds",
    Label: "耗时毫秒数",
    Type: EnumUiDynamicSearchItemType.InputNumber,
    Compares: [
      EnumCompare.GreaterThanEqual,
    ]
  },
  {
    Prop: "DynamicSearch_CompanyUser",
    Label: "执行人",
    Type: EnumUiDynamicSearchItemType.InputNumber,
    Compares: [
      EnumCompare.Contain,
    ]
  },
  {
    Prop: "DynamicSearch_CreatedTime",
    Label: "创建时间",
    Type: EnumUiDynamicSearchItemType.Customize,
    Compares: [
      EnumCompare.Between,
      EnumCompare.NoBetween,
    ]
  },
]
